import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';

import ListItemDecorator from '@mui/joy/ListItemDecorator';

import { getIcon } from 'utils/misc';

const DefaultProjectIcon = getIcon('ChecklistRtlTwoTone');
const DefaultCollabIcon = getIcon('Group');

const DefaultClickAroundIcon = getIcon('Mouse');
// import NewIcon from '@mui/icons-material/Add';



export default function CollabCreateCopy() {
    const ComputerIcon = getIcon('Computer');
    const PersonPinIcon = getIcon('PersonPin');
    const PersonAddIcon = getIcon('PersonAdd')
    const LockPersonIcon = getIcon('LockPerson')
    return (
<Sheet sx={{ m: 1 }}>

                <List>
                    <ListItem>
                        <ListItemDecorator>
                            <DefaultClickAroundIcon />
                        </ListItemDecorator>
                        <Typography level="body-sm">
                            This is a collab
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <ListItemDecorator>
                            <DefaultProjectIcon />
                        </ListItemDecorator>
                        <Typography level="body-sm">
                            Collabs are what we call "tasks/requests"
                        </Typography>
                    </ListItem>

                    <ListItem>
                        <ListItemDecorator>
                            <ComputerIcon />
                        </ListItemDecorator>
                        <Typography level="body-sm">
                            Ask us to do something that can be done from a desk
                        </Typography>
                    </ListItem>



                    <ListItem>
                        <ListItemDecorator>
                            <PersonPinIcon />
                        </ListItemDecorator>
                        <Typography level="body-sm">
We'll find the perfect person to do it
                        </Typography>
                    </ListItem>

                    <ListItem>
                        <ListItemDecorator>
                            <PersonAddIcon />
                        </ListItemDecorator>
                        <Typography level="body-sm">
                            You can invite someone specificially
                        </Typography>
                    </ListItem>

                    <ListItem>
                        <ListItemDecorator>
                            <LockPersonIcon />
                        </ListItemDecorator>
                      <Typography level="body-sm">
Send it right to your dedicated assistant
                        </Typography>
                    </ListItem>

                    <ListItem>
                        <ListItemDecorator>
                            <DefaultCollabIcon />
                        </ListItemDecorator>
                        <Typography level="body-sm">
                    Multiple people can work on this at the same time
                        </Typography>
                    </ListItem>


                </List>
            </Sheet>
    );
}
